import { CSSProperties } from 'react';

export default function ReturnsIcon({ s }: { s?: CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3412_20012)" />
      <path
        d="M32.1196 19.7491C32.1158 19.6264 32.0789 19.5047 32.0098 19.4018L28.2776 13.8219C28.1545 13.6397 27.9471 13.5293 27.7265 13.5293H22.6818C22.3163 13.5293 22.0199 13.8247 22.0199 14.1899V24.9486C22.0199 25.3119 22.3163 25.6082 22.6828 25.6082H24.0398C24.0398 27.2756 25.3968 28.6279 27.0701 28.6279C28.7434 28.6279 30.1005 27.2756 30.1005 25.6082H31.4575C31.823 25.6082 32.1204 25.3128 32.1204 24.9476L32.1213 19.768C32.1213 19.7614 32.1196 19.7548 32.1196 19.7491ZM26.0504 19.5689C25.4982 19.5689 25.0504 19.1211 25.0504 18.5689V16.5422C25.0504 15.99 25.4982 15.5422 26.0505 15.5422H27.0722C27.406 15.5422 27.7178 15.7088 27.9034 15.9862L29.2593 18.0128C29.7039 18.6772 29.2276 19.5689 28.4282 19.5689H26.0504ZM27.0703 27.1182C26.2351 27.1182 25.5552 26.4406 25.5552 25.6083C25.5552 24.776 26.2351 24.0984 27.0703 24.0984C27.9056 24.0984 28.5855 24.776 28.5855 25.6083C28.5855 26.4406 27.9056 27.1182 27.0703 27.1182ZM20.1299 11.5156H8.75865C8.27285 11.5156 7.87891 11.9082 7.87891 12.3923V24.7306C7.87891 25.2147 8.27285 25.6073 8.75865 25.6073H10.9092C10.9092 27.2747 12.2663 28.627 13.9396 28.627C15.6129 28.627 16.9699 27.2747 16.9699 25.6073H20.1309C20.6167 25.6073 21.0107 25.2147 21.0107 24.7306L21.0097 12.3923C21.0097 11.9082 20.6167 11.5156 20.1299 11.5156ZM13.9395 27.1182C13.1043 27.1182 12.4244 26.4406 12.4244 25.6083C12.4244 24.776 13.1043 24.0984 13.9395 24.0984C14.7748 24.0984 15.4547 24.776 15.4547 25.6083C15.4547 26.4406 14.7748 27.1182 13.9395 27.1182Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3412_20012"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6F3DFD" />
          <stop offset="1" stopColor="#1399D6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
